
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Das muss jeder für sich herausfinden. Denn kein Arzneimittel wirkt bei allen
gleich gut. Ein Mass ist die «number needed to treat» (NNT). Sie gibt an, wie
viele Betroffene ein Medikament nehmen müssen, damit einer davon profitiert. In
Studien wirkten die sogenannten `}<Link href='https://schmerzklinik.de/service-fuer-patienten/migraene-wissen/anfallsbehandlung/ueberblick/' mdxType="Link">{`Triptane`}</Link>{`
beim akuten Migräneanfall meist besser als Schmerzmittel oder Entzündungshemmer.
Aber das Medikament muss auch zum Patienten passen: Wer zum Beispiel ungenügend
behandelten Bluthochdruck oder Angina pectoris hat, sollte kein Triptan nehmen.
Wer hingegen schon einmal ein Magengeschwür hatte, muss mit gängigen
Schmerzmitteln wie Diclofenac, Ibuprofen oder ASS vorsichtig sein. Zu erwarten,
dass sich allein durch die Akut-Medikamente langfristige Therapieeffekte bei der
Migräne erzielen lassen, ist übrigens utopisch. Es braucht das eigene Zutun.
Fachleute empfehlen, Medikamente und nicht-medikamentöse Verfahren zu
kombinieren. `}<Link href='https://www.dgn.org/leitlinien/3583-ll-030-057-2018-therapie-der-migraeneattacke-und-prophylaxe-der-migraene' mdxType="Link">{`Hier`}</Link>{`
finden Sie einen Überblick über die unterschiedlichen Wirkstoffe von Triptanen
und ihre Nebenwirkungen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;